module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("BL List")]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-muted justify-content-center"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])])])], 1), _vm._v(" "), _c('div', [_c('div', [_c('div', [(_vm.All_BL_List_data.length > 0) ? _c('b-button', {
    staticClass: "pull-right mr-3",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export as Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('BL_LIST', 'Export as Excel')
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export as Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('b-button', {
    class: _vm.visible ? null : 'collapsed',
    attrs: {
      "variant": "outline-dark",
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v("\n        Filters")])], 1), _vm._v(" "), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.clientIdFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientIdFilter", $$v)
      },
      expression: "Filter.clientIdFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date :")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "opens": _vm.openLeft,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate
    },
    on: {
      "update": _vm.SearchFilter
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POR")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPORList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Place of Receipt"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      },
      "update": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.PORfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PORfilter", $$v)
      },
      expression: "Filter.PORfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPODList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Port of Discharge"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      },
      "update": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.PODfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PODfilter", $$v)
      },
      expression: "Filter.PODfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    on: {
      "update": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.shippingLineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "shippingLineFilter", $$v)
      },
      expression: "Filter.shippingLineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POL")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPOLList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POL"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'PortLoadList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'PortLoadList')
      },
      "update": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.LPlocationId),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "LPlocationId", $$v)
      },
      expression: "Filter.LPlocationId"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("FPOD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllLocationDetailsFinalList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select FPOD"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      },
      "update": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.finalPlaceLocationId),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "finalPlaceLocationId", $$v)
      },
      expression: "Filter.finalPlaceLocationId"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.branchfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchfilter", $$v)
      },
      expression: "Filter.branchfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Agent Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllAgentColoaderList'],
      "id": "ToFilter",
      "option-value": "agentName",
      "option-text": "agentName",
      "placeholder": "All"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.ToFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "ToFilter", $$v)
      },
      expression: "Filter.ToFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Consignee")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllConsigneeList'],
      "id": "Consignee",
      "option-value": "consignee",
      "option-text": "consignee",
      "placeholder": "Select Consignee"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.Consignee),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "Consignee", $$v)
      },
      expression: "Filter.Consignee"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Consignor")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllConsignorList'],
      "id": "Consignor",
      "option-value": "consignorName",
      "option-text": "consignorName",
      "placeholder": "Select Consignor"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.Consignor),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "Consignor", $$v)
      },
      expression: "Filter.Consignor"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Assignment No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Assignment No.",
      "id": "assignmentNo",
      "name": "assignmentNo"
    },
    model: {
      value: (_vm.Filter.assignmentNo),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "assignmentNo", $$v)
      },
      expression: "Filter.assignmentNo"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3 row justify-content-center"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.filterSearch
    }
  }, [_vm._v("Search\n            ")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain mt-2"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.All_BL_List_data,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "ffExportFclId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "bldetails",
      fn: function(row1) {
        return [_c('b', {
          staticClass: "text-danger",
          on: {
            "click": function($event) {
              _vm.PrintNote(row1.item.uploadBL, row1.item.assignment_number)
            }
          }
        }, [_vm._v(_vm._s(row1.item.BlNumber))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("BL Stage: "), _c('b', [_vm._v(_vm._s(row1.item.blStage))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("BL Date: "), _c('b', [_vm._v(_vm._s(row1.item.blDate))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("BL Created By: "), _c('b', [_vm._v(_vm._s(row1.item.BlRaisedBy))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("BL Created At: "), _c('b', [_vm._v(_vm._s(row1.item.BlCreatedAt))])])]
      }
    }, {
      key: "AssignementDetails",
      fn: function(row21) {
        return [_c('b', [_vm._v("Assignement Number : " + _vm._s(row21.item.assignment_number))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Assignement Date : " + _vm._s(_vm._f("moment")(row21.item.assigement_date)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Raised From : " + _vm._s(row21.item.RasiedFrom))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Rasied By : " + _vm._s(row21.item.username))])]
      }
    }, {
      key: "OtherDetails",
      fn: function(row3) {
        return [_c('span', [_c('b', [_vm._v("POD")]), _vm._v(" : " + _vm._s(row3.item.POD))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("POL")]), _vm._v(" : " + _vm._s(row3.item.POL))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("POR")]), _vm._v(" : " + _vm._s(row3.item.POR))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("FPOD")]), _vm._v(" : " + _vm._s(row3.item.FPOD))]), _vm._v(" "), _c('br')]
      }
    }, {
      key: "clientName",
      fn: function(row4) {
        return [_c('span', [_vm._v("Client Name : "), _c('b', [_vm._v(_vm._s(row4.item.clientName))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Shipper Name : "), _c('b', [_vm._v(_vm._s(row4.item.ShippingLine))])])]
      }
    }, {
      key: "consignor",
      fn: function(row5) {
        return [_c('span', [_vm._v(_vm._s(row5.item.consignor))])]
      }
    }, {
      key: "consignee",
      fn: function(row6) {
        return [_c('span', [_vm._v(_vm._s(row6.item.consignee))])]
      }
    }, {
      key: "agentdetails",
      fn: function(row7) {
        return [_c('span', [_vm._v(_vm._s(row7.item.agentName))])]
      }
    }, {
      key: "notify",
      fn: function(row8) {
        return [_c('span', [_vm._v(_vm._s(row8.item.notify))])]
      }
    }, {
      key: "description",
      fn: function(row9) {
        return [_c('span', [_vm._v(_vm._s(row9.item.description))])]
      }
    }, {
      key: "UsNonUs",
      fn: function(row10) {
        return [_c('span', [_vm._v(_vm._s(row10.item.location))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "5",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c360a3b0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/freightForwarding/bl-list.vue
// module id = 2853
// module chunks = 0